import { RootState } from '../../../types';

export const selectSession = (state: RootState) => state.session;
